import React from 'react';

/** Shown when the user lacks the credit product required for this event's interactive area. */
export default function EventAreaLockedNotice() {
  return (
    <div className="EventLivestream-area-locked" role="status">
      <p>
        Et näe tätä pelialuetta, koska sinulta puuttuu kyseinen tuote. Osta se krediiteillä{' '}
        <a href="/kauppa">täältä</a>.
      </p>
    </div>
  );
}
